export default __webpack_public_path__ + "static/media/onboarding_icons_transparent.c699ec11.riv";